import React from 'react';
import {useParams} from 'react-router-dom';
import {useTranslation} from '../../../hook/useTranslation';
import './Text.scss';
import Button from '../../button/Button';
import Contact from '../../contact/Contact';

export default function LayoutText() {
    const {translationPath} = useParams<'translationPath'>();
    const i18n = useTranslation();

    return (
        <div className="career-model__text">
            <div className="career-model__text--content">
                <div className="career-model__text--header">
                    <Button text="Back"
                            uri={i18n.translate(`show.back_link`) + i18n.translate(`show.items.${translationPath}.links.back_link`)}
                            additionalClass="icon-only icon-back"/>
                </div>
                <h1 className="career-model__text--title">{i18n.translate(`show.items.${translationPath}.title`)}</h1>
                {i18n.translate(`show.items.${translationPath}.subtitle`) &&
                    <h2 className="career-model__text--sub-title">{i18n.translate(`show.items.${translationPath}.subtitle`)}</h2>
                }
                {i18n.translate(`show.items.${translationPath}.description`) &&
                    <p className="career-model__text--desc"
                       dangerouslySetInnerHTML={{__html: i18n.translate(`show.items.${translationPath}.description`)}}></p>
                }
                {i18n.translate(`show.items.${translationPath}.items_title`) &&
                    <h2 className="career-model__text--items-title">{i18n.translate(`show.items.${translationPath}.items_title`)}</h2>
                }
                <div className="career-model__text--links-wrap">
                    <div className="career-model__text--links">
                        {i18n.keyExists(`show.items.${translationPath}.items.0.title`) &&
                            <div className="career-model__text--link">
                                <h3 className="career-model__text--link-title">
                                    {i18n.translate(`show.items.${translationPath}.items.0.title`)}
                                </h3>
                                <p className="career-model__text--link-desc"
                                   dangerouslySetInnerHTML={{__html: i18n.translate(`show.items.${translationPath}.items.0.description`)}}></p>
                            </div>
                        }
                        {i18n.keyExists(`show.items.${translationPath}.items.1.title`) &&
                            <div className="career-model__text--link">
                                <h3 className="career-model__text--link-title">
                                    {i18n.translate(`show.items.${translationPath}.items.1.title`)}
                                </h3>
                                <p className="career-model__text--link-desc"
                                   dangerouslySetInnerHTML={{__html: i18n.translate(`show.items.${translationPath}.items.1.description`)}}></p>
                            </div>
                        }
                        {i18n.keyExists(`show.items.${translationPath}.items.2.title`) &&
                            <div className="career-model__text--link">
                                <h3 className="career-model__text--link-title">
                                    {i18n.translate(`show.items.${translationPath}.items.2.title`)}
                                </h3>
                                <p className="career-model__text--link-desc"
                                   dangerouslySetInnerHTML={{__html: i18n.translate(`show.items.${translationPath}.items.2.description`)}}></p>
                            </div>
                        }
                        {i18n.keyExists(`show.items.${translationPath}.items.3.title`) &&
                            <div className="career-model__text--link">
                                <h3 className="career-model__text--link-title">
                                    {i18n.translate(`show.items.${translationPath}.items.3.title`)}
                                </h3>
                                <p className="career-model__text--link-desc"
                                   dangerouslySetInnerHTML={{__html: i18n.translate(`show.items.${translationPath}.items.3.description`)}}></p>
                            </div>
                        }
                    </div>
                </div>
            </div>
            {
                i18n.keyExists(`show.items.${translationPath}.override.contact.person.name`) ? (
                    <Contact title={i18n.translate(`show.items.${translationPath}.override.contact.title`)}
                             person={{
                                 email: i18n.translate(`show.items.${translationPath}.override.contact.person.email`),
                                 emailLabel: i18n.translate(`show.items.${translationPath}.override.contact.person.email-label`),
                                 image: i18n.translate(`show.items.${translationPath}.override.contact.person.image`),
                                 name: i18n.translate(`show.items.${translationPath}.override.contact.person.name`),
                                 phone: i18n.translate(`show.items.${translationPath}.override.contact.person.phone`),
                                 title: i18n.translate(`show.items.${translationPath}.override.contact.person.title`)
                             }}/>
                ) : (
                    i18n.keyExists(`show.items.${translationPath}.override.contact.text`) ? (
                        <Contact title={i18n.translate(`show.items.${translationPath}.override.contact.title`)}
                                 text={i18n.translate(`show.items.${translationPath}.override.contact.text`)}/>
                    ) : (
                        <Contact title={i18n.translate('show.contact.title')}
                                 person={{
                                     email: i18n.translate('show.contact.person.email'),
                                     emailLabel: i18n.translate('show.contact.person.email-label'),
                                     image: i18n.translate('show.contact.person.image'),
                                     name: i18n.translate('show.contact.person.name'),
                                     phone: i18n.translate('show.contact.person.phone'),
                                     title: i18n.translate('show.contact.person.title')
                                 }}/>
                    )
                )}
        </div>
    );
};
